import React from 'react';
import { Spinner } from '../../../../flayr-components';
import ErrorMsg from '../../../../lib/ErrrorMsg/ErrorMsg';
import SuccessMsg from '../../../../lib/SuccessMsg/SuccessMsg';

interface IFinishStepProps {
  loading: boolean;
  success?: string;
  err?: string;
  providerName: string;
}

const FinishStep: React.FC<React.PropsWithChildren<React.PropsWithChildren<IFinishStepProps>>> = ({
  loading,
  err,
  providerName,
  success,
}) => {
  return (
    <div className="flex items-center content-center py-8">
      <div className="mx-auto">
        <Spinner showing={loading} />

        {!!err && <ErrorMsg message={err} />}
        {!!success && (
          <SuccessMsg
            message={
              <div className="text-center">
                <div className="my-8 text-xl font-medium md:text-2xl">
                  Availability Check in Progress
                </div>
                <div className="md:text-lg">{success}</div>

                <div className="mt-12 md:text-base">
                  Most customers request 3 additional providers
                </div>
              </div>
            }
          />
        )}
      </div>
    </div>
  );
};
export default FinishStep;
